export default {
	authTokenKey: "x-account-auth-token"
}
